import { useLang } from "@/i18n/LanguageContext";

export const Marquee = () => {
  const { t } = useLang();
  const row = [...t.marquee.items, ...t.marquee.items];
  return (
    <div
      data-testid="editorial-marquee"
      className="marquee-track overflow-hidden border-y border-border bg-cream/60 py-5 select-none"
      aria-hidden="true"
    >
      <div className="marquee-inner animate-marquee flex w-max items-center gap-10 pr-10">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-10">
                <span
                  className={`whitespace-nowrap text-lg sm:text-xl ${
                    i % 2 === 0 ? "font-serif italic text-espresso" : "text-xs uppercase tracking-[0.3em] font-semibold text-taupe"
                  }`}
                >
                  {item}
                </span>
                <span className="w-1.5 h-1.5 rounded-full bg-terracotta/60 shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
